import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { IMultiCarryoverComments } from "../../interfaces/firedepartment-bc-turnover/multCarryoverComments";
import { FireDepartmentsBcTurnoversService } from "../../services/firedepartments/fireDepartmentsBcTurnovers.service";
import { LoggedUserService } from "../../services/common/logged-user.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";

@Component({
  selector: "app-carryover-comments-update",
  templateUrl: "./carryover-comments-update.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class CaryoverCommentsUpdateComponent implements OnInit {
  updateCommentsForm: FormGroup;

  // Output events to communicate with parent
  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  selectedCrew: IPicklistValuesData;
  selectedShift: IPicklistValuesData;
  selectedCategory: IPicklistValuesData;
  validationMessages: string[] = [];
  currentUser: ILoggedUserData;

  constructor(
    private fb: FormBuilder,
    private fireDepartmentsBcTurnoversService: FireDepartmentsBcTurnoversService,
    private loggedUserService: LoggedUserService
  ) {
    this.updateCommentsForm = this.fb.group({
      allUpdates: [false],
      category: ["-1"],
      crew: ["-1"],
      shift: ["-1"],
    });
  }

  ngOnInit(): void {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.currentUser = user;
    });
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onShiftSelected(shift: IPicklistValuesData): void {
    this.selectedShift = shift;
  }

  onCategorySelected(category: IPicklistValuesData): void {
    this.selectedCategory = category;
  }

  onSubmit() {
    this.validationMessages = [];
    if (this.updateCommentsForm.value.allUpdates === true) {
      this.updateCommentsForm.controls.category.setValue("-1");
    }

    if (
      !this.updateCommentsForm.value.allUpdates &&
      (this.updateCommentsForm.get("category")?.value === "" ||
        this.updateCommentsForm.get("category")?.value === "-1")
    ) {
      this.validationMessages.push(
        "Select a category or check the 'All Updates' checkbox"
      );
    }

    if (
      this.updateCommentsForm.get("crew")?.value === "" ||
      this.updateCommentsForm.get("crew")?.value === "-1"
    ) {
      this.validationMessages.push("Crew field is requried");
    }

    if (
      this.updateCommentsForm.get("shift")?.value === "" ||
      this.updateCommentsForm.get("shift")?.value === "-1"
    ) {
      this.validationMessages.push("Shift filed is required");
    }

    if (this.validationMessages.length > 0) {
      return;
    }

    this.validationMessages = [];
    let isForAll = this.updateCommentsForm.value.allUpdates;
    let obj: IMultiCarryoverComments = {
      crewId: this.selectedCrew.id,
      shiftId: this.selectedShift.id,
      categoryId: !isForAll ? this.selectedCategory.id : 0,
      createDate: new Date(),
      turnoverCategory: parseInt(
        this.updateCommentsForm.get("category")?.value
      ),
      isForAll: isForAll,
      facilityId: Number(this.currentUser?.facilityId) || 1,
      createdById: Number(this.currentUser?.id) || 1,
    };

    this.fireDepartmentsBcTurnoversService
      .multiUpdateCarryoverComments(obj)
      .subscribe((data) => {
        this.updateCommentsForm.reset();
        this.saved.emit(data.length);
      });
  }

  cancel(): void {
    this.updateCommentsForm.reset();
    this.cancelled.emit();
  }
}
